<script setup lang="ts">
import type { DataTableHeaders } from '@/plugins/vuetify';
const dialog = defineModel<boolean>()
const headers = defineModel<DataTableHeaders>('headers')
const visible = defineModel<any[]>('visibleheaders')
</script>
<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h5 text-medium-emphasis">Choisir les colonnes à afficher</span>
        <v-btn icon @click="dialog = false">
          <v-icon>M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text class="mt-4">
        <v-select
          v-model="visible"
          :items="headers?.map(header => ({ text: header.title, value: header.key }))"
          :item-title="x => x.text"
          multiple chips/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
